import Service from "../../AuthService";

const RealizedGainLoss = {
    getRealizedGainLoss() {
        return Service.get("/realized_gain_loss")
    },
    getRealizedGainLossById(id) {
        return Service.get("/realized_gain_loss/" + id)
    },
    createRealizedGainLoss(data) {
        return Service.post("/realized_gain_loss", data)
    },
    updateRealizedGainLoss(id, data) {
        return Service.put("/realized_gain_loss/" + id, data)
    },
    deleteRealizedGainLoss(id) {
        return Service.delete("/realized_gain_loss/" + id)
    },
    getRealizedGainLossPerMonth(month,year){
        return Service.get("/realized_gain?month="+month+
            "&year="+year)
    }
};

export default RealizedGainLoss
